/** Shared Framer Motion springs / viewport for ALA cinematic home. */
export const alaSpring = {
  type: 'spring' as const,
  stiffness: 90,
  damping: 16,
  mass: 0.9,
};

export const alaViewport = { once: true } as const;
